import { OVEntity, OVField, OVSearch, OVTable } from '@ov-suite/ov-metadata';
import { Rag } from '@ov-suite/helpers-shared';
import { ProductSkuModel } from '@ov-suite/models-admin';
import { UserModel } from '@ov-suite/models-idm';

@OVTable<InventoryHeldByUserCountModel>([
  {
    title: 'Held By User',
    type: 'other',
    keys: ['heldByUser.firstName', 'heldByUser.lastName'],
    action: val => `${val.heldByUser?.firstName ?? ''} ${val.heldByUser?.lastName ?? ''}`.trim(),
  },
  {
    title: 'Count',
    type: 'number',
    key: 'quantity',
  },
  {
    title: 'Product',
    type: 'deep-string',
    key: 'productSku.name',
  },
  {
    title: 'SKU',
    type: 'deep-string',
    key: 'productSku.sku',
  },
  {
    title: 'Status',
    type: 'other',
    action: val => {
      switch (val.rag) {
        case Rag.amber:
          return `<span style="color: orange">●</span>`;
        case Rag.green:
          return `<span style="color: green">●</span>`;
        case Rag.red:
          return `<span style="color: red">●</span>`;
        default:
          return 'missing';
      }
    },
    keys: ['rag', 'heldByUser.id'],
    disableSorting: true,
    disableFiltering: true,
  },
])
@OVSearch<InventoryHeldByUserCountModel>({
  searchKeys: ['heldByUser.firstName', 'heldByUser.lastName', 'productSku.name', 'productSku.sku'],
})
@OVEntity({ name: 'InventoryHeldByUserLevels' })
export class InventoryHeldByUserCountModel {
  @OVField({ type: 'number' })
  id: number;

  @OVField({ type: () => UserModel })
  heldByUser: UserModel;

  @OVField({ type: () => ProductSkuModel })
  productSku: ProductSkuModel;

  @OVField({ type: 'number' })
  quantity: number;

  @OVField({ type: 'date' })
  enterTime: Date;

  @OVField({ type: 'date' })
  exitTime?: Date;

  @OVField({ type: 'number' })
  rag: Rag;
}
